var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { ShiftIntervalList } from '.';
import { gql } from '@apollo/client';
import { ShiftIntervalBlockFeature } from './ShiftIntervalBlock';
import { useDesiredShiftIntervals } from './hooks';
export var ShiftIntervalListFeature = function (_a) {
    var shiftIntervals = _a.shiftIntervals, filterWorkIntervals = _a.filterWorkIntervals, hideIntervalSkill = _a.hideIntervalSkill;
    var sortedDesiredShiftIntervals = useDesiredShiftIntervals({
        shiftIntervals: shiftIntervals,
        filterWorkIntervals: filterWorkIntervals,
        hideIntervalSkill: hideIntervalSkill
    });
    if (sortedDesiredShiftIntervals.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(ShiftIntervalList, { shiftIntervals: sortedDesiredShiftIntervals });
};
ShiftIntervalListFeature.fragments = {
    shiftIntervals: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment ShiftIntervalList_ShiftInterval on ShiftInterval {\n            ...ShiftIntervalBlockFeature_ShiftInterval\n        }\n\n        ", "\n    "], ["\n        fragment ShiftIntervalList_ShiftInterval on ShiftInterval {\n            ...ShiftIntervalBlockFeature_ShiftInterval\n        }\n\n        ", "\n    "])), ShiftIntervalBlockFeature.fragments.shiftIntervals)
};
var templateObject_1;
